import Styles from './NewsletterStyleInput.module.scss'
import { useField } from 'formik'
import { Radio, RadioGroup } from 'components/RadioGroup'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { HighDetailedEngagement } from 'blaze-ui/icons'
import { HighDetailedAds, HighDetailedScheduled } from 'blaze-ui/icons/24'
import cx from 'classnames'
import { DocHighDetailed } from 'blaze-ui/icons/40'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export enum NewsletterStyles {
  Promotional = 'Promotional',
  Editorial = 'Editorial',
  Announcement = 'Announcement',
  Other = 'Other',
}

export const NewsletterStyleInput = () => {
  const { isMobile } = useResponsiveDesign()
  const [selectedStyle, , { setValue: setSelectedStyle }] = useField('newsletter_style')

  return (
    <RadioGroup
      aria-label="Title"
      value={selectedStyle.value}
      className={Styles.radioGroup}
      onChange={(selectedNewContent) => {
        setSelectedStyle(selectedNewContent)
      }}
    >
      <Radio
        className={cx(Styles.radioOption, { [Styles.selected]: selectedStyle.value === 'Promotional' })}
        value="Promotional"
        hideRadio
      >
        {(radioBulletProps) => (
          <>
            <div className={Styles.radioBullet}>
              <HighDetailedAds size={30} />
              <RadioBullet {...radioBulletProps} size={20} />
            </div>
            <Heading level={5}>Promotional</Heading>
            <Text variant="secondary" color="var(--dark-80)">
              {isMobile ? 'Highlights offers to drive action.' : 'Highlights offers or products to drive action.'}
            </Text>
          </>
        )}
      </Radio>
      <Radio
        className={cx(Styles.radioOption, { [Styles.selected]: selectedStyle.value === 'Editorial' })}
        value="Editorial"
        hideRadio
      >
        {(radioBulletProps) => (
          <>
            <div className={Styles.radioBullet}>
              <DocHighDetailed size={30} />
              <RadioBullet {...radioBulletProps} size={20} />
            </div>
            <Heading level={5}>Editorial</Heading>
            <Text variant="secondary" color="var(--dark-80)">
              {isMobile ? 'Shares stories to inform or inspire.' : 'Shares stories or content to inform or inspire.'}
            </Text>
          </>
        )}
      </Radio>
      <Radio
        className={cx(Styles.radioOption, { [Styles.selected]: selectedStyle.value === 'Announcement' })}
        value="Announcement"
        hideRadio
      >
        {(radioBulletProps) => (
          <>
            <div className={Styles.radioBullet}>
              <HighDetailedEngagement size={30} />
              <RadioBullet {...radioBulletProps} size={20} />
            </div>
            <Heading level={5}>Announcement</Heading>
            <Text variant="secondary" color="var(--dark-80)">
              Delivers important updates or news.
            </Text>
          </>
        )}
      </Radio>
      <Radio
        className={cx(Styles.radioOption, { [Styles.selected]: selectedStyle.value === 'Weekly Update' })}
        value="Weekly Update"
        hideRadio
      >
        {(radioBulletProps) => (
          <>
            <div className={Styles.radioBullet}>
              <HighDetailedScheduled size={30} />
              <RadioBullet {...radioBulletProps} size={20} />
            </div>
            <Heading level={5}>Weekly Update</Heading>
            <Text variant="secondary" color="var(--dark-80)">
              Recaps recent news or highlights.
            </Text>
          </>
        )}
      </Radio>
    </RadioGroup>
  )
}
